import { render } from "./ProfileMenu.vue?vue&type=template&id=5d15480e&scoped=true"
import script from "./ProfileMenu.vue?vue&type=script&lang=js"
export * from "./ProfileMenu.vue?vue&type=script&lang=js"

import "./ProfileMenu.vue?vue&type=style&index=0&id=5d15480e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d15480e"]])

export default __exports__